import { useEffect } from 'react';

/**
 * Focuses the first field in a form when the component mounts.
 * @param {React.RefObject<HTMLFormElement | null>} formRef - A reference to the form element.
 */
export function useFocusFirstField(formRef) {
  useEffect(() => {
    if (formRef.current) {
      const firstField = formRef.current?.querySelector('input, select, textarea');
      if (firstField instanceof HTMLElement) {
        firstField.focus();
      }
    }
  }, [formRef]);
}
